import React, { useState } from "react";
import ChatRoom from "../components/ChatRoom";

export default function App() {
  const [room, setRoom] = useState("");
  const [joined, setJoined] = useState(false);

  const joinChat = () => {
    if (room.trim()) {
      setJoined(true);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-b from-gray-800 to-gray-900 text-white p-4">
      {!joined ? (
        <div className="bg-gray-700 p-8 rounded-xl shadow-2xl w-96 border border-gray-600">
          <h2 className="text-2xl font-bold mb-6 text-center text-blue-300">Join Anonymous Chat</h2>
          
          <select
            className="w-full p-3 mb-6 border rounded-lg bg-gray-800 border-gray-600 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={room}
            onChange={(e) => setRoom(e.target.value)}
          >
            <option value="">Select a Room</option>
            <option value="interactive-session">Interactive Session</option>
          </select>
          
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-3 rounded-lg w-full font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
            onClick={joinChat}
            disabled={!room.trim()}
          >
            Join Anonymous Chat
          </button>
        </div>
      ) : (
        <ChatRoom room={room} onLeave={() => setJoined(false)} />
      )}
    </div>
  );
}